import { AppSettings } from "../../app-settings";
import { KeyParagraphQuoteModel } from "../../desktop/models/key-paragraph-quote";
import { KeyParagraphSentenceModel } from "../../desktop/models/key-paragraph-sentence";
import { prop } from "../../decorators/property";
import { backboneModelProperties } from "../../decorators/backbone-properties";

@backboneModelProperties({
    urlRoot: AppSettings.ApiUrlPrefix + "/full-text-sources",
    relations : [
        {
            type: Backbone.Many,
            key: "Quotes",
            relatedModel: KeyParagraphQuoteModel
        },
        {
            type: Backbone.Many,
            key: "Sentences",
            relatedModel: KeyParagraphSentenceModel
        }
    ]
})
export class KeyParagraphModel extends Backbone.AssociatedModel {
    @prop() public ParagraphNumber: number;
    @prop() public Quotes: Backbone.Collection<KeyParagraphQuoteModel>;
    @prop() public Sentences: Backbone.Collection<KeyParagraphSentenceModel>;

    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/models/key-paragraph.ts